// /my-profile/recommended
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';

import { getAnotherRecommendedNews } from '@/store/user-topics/actions';

import { selectUserTopics } from '@/store/user-topics/selectors';

import { FloatButton, Layout, Radio, Spin } from 'antd';
import NewsElement from '@/pages/MyProfile/News/NewsElement';
import CustomEmpty from '@/components/CustomEmpty';
import ListItem from '@/components/MaterialListItem';

import { isEvent } from '@shared/utils/topic-utils';

import dayjs from 'dayjs';

import css from '../info.module.scss';

const GROUP_TYPES = {
  MATERIALS: 'materials',
  NEWS: 'news',
};

const { Content } = Layout;
const { Button, Group } = Radio;

const RecommendedTopic = () => {
  const {
    dataqa,
    profileId,
    onFavoriteClick,
    updateInfinityScrollRecommended,
    onStudyPlanClick,
    onDeleteClick,
    externalLogin,
    hideActionButtons,
    openDate,
  } = useOutletContext();
  const { t } = useTranslation('recommendedTopic');
  const dispatch = useDispatch();

  const { recommended, isRecommendedLoading } = useSelector(selectUserTopics);

  const [currentType, setCurrentType] = useState(GROUP_TYPES.MATERIALS);

  const listMaterials = recommended?.elements?.map((item, index) => (
    <ListItem
      dataqa={dataqa}
      key={`${item.id}-${index}`}
      user={item.user}
      topic={{ ...item.topic, userPlanType: item.userPlanType }}
      profileId={profileId}
      onFavoriteClick={onFavoriteClick}
      theLast={recommended?.elements?.length - 1 === index}
      {...(item.topic
        ? {
            checkIsEnd:
              item.topic.type &&
              isEvent(item.topic.type.id) &&
              dayjs(`${item.topic.endDate} ${item.topic.endTime}`).isBefore(dayjs()),
          }
        : {
            checkIsEnd:
              item.type && isEvent(item?.type?.id) && dayjs(`${item.endDate} ${item.endTime}`).isBefore(dayjs()),
          })}
      onStudyPlanClick={onStudyPlanClick}
      onDeleteClick={onDeleteClick}
      page={recommended.page}
      typeList='recommended'
      recUsers={item.recUsers}
      lastRec={item.recUsers?.filter(rec => rec.id === item.recBy)}
      isExternalLogin={externalLogin}
      hideActionButtons={hideActionButtons}
      openDate={openDate}
    />
  ));

  useEffect(() => {
    dispatch(getAnotherRecommendedNews(0));
  }, []);

  return (
    <Content className={css.RecommendedTopic}>
      <div className={css.RecommendedTopic__content}>
        <Group
          value={currentType}
          onChange={event => setCurrentType(event.target.value)}
          className={css.RecommendedTopic__group}
          data-qa='materialsAndNewsBtns'
        >
          <Button key='GROUP_TYPES.MATERIALS' value={GROUP_TYPES.MATERIALS}>
            {t('materials')}
          </Button>
          <Button key='GROUP_TYPES.NEWS' value={GROUP_TYPES.NEWS}>
            {t('news')}
          </Button>
        </Group>

        {currentType === GROUP_TYPES.NEWS ? (
          <NewsElement
            type='recommended'
            emptyContent={{
              title: t('nothingYet'),
              description: t('description3News'),
            }}
          />
        ) : (
          <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            loadMore={e => {
              if (!isRecommendedLoading) updateInfinityScrollRecommended(e);
            }}
            hasMore={recommended.hasMore}
            threshold={250}
            loader={
              <div key='unique-loader' className={css.RecommendedTopic__loader}>
                <Spin size='large' spinning={isRecommendedLoading} />
              </div>
            }
          >
            {recommended.elements?.length === 0 && !isRecommendedLoading ? (
              <CustomEmpty title={t('nothingYet')} description={t('description3')} />
            ) : (
              listMaterials
            )}
          </InfiniteScroll>
        )}
      </div>
      <FloatButton.BackTop />
    </Content>
  );
};

export default RecommendedTopic;
